import HiddenInput from 'pu-react/components/base/HiddenInput';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectBomDataForCart } from 'pcb-parts/slice/selectors';
import { selectProjectParameters } from 'project_quote/data/selectors';

const HiddenFields = ({ itemId }) => {
  const groupName = `items[${itemId}][parameters]`;
  const { part_number } = useSelector(selectProjectParameters);
  const { partsDataForForms: { bom } } = useSelector(selectBomDataForCart);
  const {
    bomVariant,
    bomRevision,
    bomSaved,
    bomProductQuoteNumber,
    bomQuantity,
    bom_file,
  } = bom;

  return (
    <>
      <HiddenInput name="part_number" value={part_number} groupName={groupName} />
      <HiddenInput name="variant_id" value={bomVariant} groupName={`items[${itemId}]`} />
      <HiddenInput name="quantity" value={bomQuantity} groupName={`items[${itemId}]`} />
      <HiddenInput name="revision" value={bomRevision} groupName={groupName} />
      <HiddenInput name="item_selected" value={bomSaved} groupName={groupName} />
      <HiddenInput name="quantity_selected" value={bomQuantity} groupName={groupName} />
      <HiddenInput name="bom_quote_number" value={bomProductQuoteNumber} groupName={groupName} />
      <HiddenInput name="bom_file" value={bom_file} groupName={groupName} />
    </>
  );
}

export default HiddenFields;